
import React from 'react';
import Button from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/224dc00200a5f30b66b07d4513abc50a/d70c60bad8bc8c9c44d31f67e9311de1.jpeg')`
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-sm md:text-lg font-bold text-white mb-6 font-serif leading-tight">
            Build Wealth Through <span className="text-yellow-600 italic">Ownership</span> — Not Overwork.
          </h1>
          
          <p className="text-base md:text-lg text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
            Helping professionals and business owners acquire, scale, and sell businesses — strategically, profitably, and with purpose.
          </p>
          
          <div className="mb-12">
            <p className="text-sm md:text-base text-gray-300 mb-6 max-w-2xl mx-auto">
              I'm Glory Odudu, an Investor, Speaker, and Deal Maker helping professionals transition from employees to business owners and helping existing owners grow or exit through smart acquisitions.
            </p>
            
            <blockquote className="text-lg md:text-xl font-serif italic text-yellow-600 mb-8">
              "You can't outwork a ceiling — but you can acquire a business that breaks it."
            </blockquote>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="primary" size="lg" className="min-w-[200px]">
              Book a Strategy Call
            </Button>
            <Button variant="outline" size="lg" className="min-w-[200px]">
              Join the Waitlist
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
